import React from 'react';
import { Paper, CardContent, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

const SalesSummary = ({ dashboard }) => {
    const { t } = useTranslation();

    return (
        <Paper
            sx={{
                flex: 1,
                width: { xs: '100%', md: '30%' },
                minWidth: { xs: '100%', md: '300px' },
                maxWidth: { xs: '100%', md: '400px' },
                padding: 2,
            }}
            elevation={0}
        >
            <CardContent>
                {
                    dashboard.topPlatforms?.length > 0 && (<>
                        <Typography
                            variant="h6"
                            sx={{ textAlign: 'center', fontWeight: 'bold' }}
                        >
                            {t('salesSummary.topPlatformsTitle', { count: 5 })}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{
                                textAlign: 'center',
                                color: '#757575',
                                marginTop: 2,
                            }}
                        >
                            {dashboard.topPlatforms?.map((platform, index) => (
                                <Typography
                                    key={index}
                                    variant="body"
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        textAlign: 'center',
                                        gap: 1,
                                        borderBottom: "1px solid #ddd",
                                        paddingY: 1,
                                        color: "#333",
                                    }}
                                >
                                    {index === 0 && "🥇"}
                                    {index === 1 && "🥈"}
                                    {index === 2 && "🥉"}
                                    {index >= 3 && "⬆"}
                                    {platform.platformName} - ${platform.totalAmount.toFixed(2)}
                                </Typography>
                            ))}
                        </Typography>
                    </>)
                }
            </CardContent>
        </Paper>
    )
}

export default SalesSummary;